import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import moment, { months } from 'moment';
import Swal from 'sweetalert2';
import ExcelJS from 'exceljs';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import { baseAPI } from '../../services/baseAPI';


function Invoice() {
  const { id, npp } = useParams();
  const history = useHistory();
  const BENDAHARA = 5;
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(false);
  const [dataInvoice, setDataInvoice] = useState();
  const [dataAnggota, setDataAnggota] = useState([]);
  const [time, setTime] = useState(new Date ());
  const [showInv, setShowInv] = useState(false);


  // CONTROLLER
  const fetchInvoice = async () => {
    setIsLoading(true);
    const monthYear = moment(time).format("MMYYYY");
    await baseAPI
      .get(`/v1/invoice/${monthYear}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const inv = res.data.data;
        const invRes = res.data.data.total;

        setDataInvoice(inv);
        setDataAnggota(invRes.res_anggota);
        setShowInv(true);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(`error ${error}`);
      })
  };

  function monthToRoman(month) {
    const romanNumerals = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];

    // Check if the provided month is valid
    if (month >= 1 && month <= 12) {
      return romanNumerals[month - 1];
    } else {
      return 'Invalid month';
    }
  };
  
  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='#' style={{ color: '#333' }}>Kas</Link> /{' '}
              <Link to='/kas/invoice' style={{ color: '#333' }}>Cetak Invoice</Link>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const addView = () => (
    <div className='row row-deck row-cards mb-3'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Download Invoice</b></p>
              </div>

              {/* Jenis Pencatatan */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Pilih Bulan dan Tahun
                </label>
                <DatePicker
                  selected={time}
                  onChange={(date) => setTime(date)}
                  dateFormat="MM/yyyy"
                  className="form-control datepicker"
                  showMonthYearPicker
                />
              </div>

              <div className='col-md-12'>
                <button
                  type="button"
                  className='btn btn-danger col-md-12'
                  style={{backgroundColor: '#CD5C08'}}
                  onClick={() => fetchInvoice()}
                >
                  Get Data Invoice
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  );

  const exportToExcel = async () => {
    try {
      // Set loading state to true
      setIsLoading(true);
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Lampiran Rincian Invoice');
      const worksheet2 = workbook.addWorksheet('INVOICE');
  
      const tableColumns = [
        { header: 'No', key: 'no', width: 5 },
        { header: 'No Anggota', key: 'noAnggota', width: 15 },
        { header: 'NPP', key: 'npp', width: 15 },
        { header: 'Nama Anggota', key: 'namaAnggota', width: 25 },
        { header: 'Total Simpanan Pokok', key: 'totalSimpananPokok', width: 20 },
        { header: 'Total Simpanan Wajib', key: 'totalSimpananWajib', width: 20 },
        { header: 'Total SPN', key: 'totalSPN', width: 15 },
        { header: 'Total Tabungan Berjangka', key: 'totalTabunganJangka', width: 20 },
        { header: 'Total Angsuran Pinjam Tunai', key: 'totalAngsuranTunai', width: 25 },
        { header: 'Total Angsuran Pinjam Barang', key: 'totalAngsuranBarang', width: 25 },
        { header: 'Total', key: 'total', width: 20 },
      ];
  
      const resAnggota = dataAnggota;
      const rowData = []
      resAnggota.forEach((data, index) => {
        rowData.push({
          no: index + 1,
          noAnggota: data.idkopkar,
          npp: data.npp_anggota,
          namaAnggota: data.name_anggota,
          totalSimpananPokok: data.total_pokok,
          totalSimpananWajib: data.total_wajib,
          totalSPN: data.total_spn,
          totalTabunganJangka: data.total_tabungan,
          totalAngsuranTunai: data.total_tunai,
          totalAngsuranBarang: data.total_barang,
          total: data.total_all,
        });
      });

      const headerRow = worksheet.addRow(tableColumns.map(column => column.header));
      headerRow.eachCell((cell, index) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center' };
      });

      rowData.forEach(data => {
        const row = worksheet.addRow(Object.values(data));
        row.eachCell((cell, index) => {
          cell.alignment = { horizontal: 'center' };
        });
      });


      tableColumns.forEach((column, index) => {
        worksheet.getColumn(index + 1).width = column.width;
      });

    
      // Add the image using the 'image' module
      const logoImage = await workbook.addImage({
        base64: await getBase64Image(`${process.env.PUBLIC_URL}/static/logo_inv.png`),
        extension: 'png',
      });
    
      worksheet2.addImage(logoImage, {
        tl: { col: 0, row: 0 },
        ext: { width: 339.5, height: 119.7 },
      });
    
      // MergedCell for "Invoice" in bold
      worksheet2.getCell('B8').value = 'INVOICE KOPERASI KARYAWAN';
      worksheet2.getCell('B8').font = { bold: true, size: 16 };
      worksheet2.getCell('B8').alignment = { horizontal: 'right' };
      worksheet2.mergeCells('B8:D8');
    
      // Resize the column containing "INVOICE KARYAWAN..." text
      worksheet2.getColumn('A').width = 6.09; // Change this to your desired width
      worksheet2.getColumn('B').width = 44.55; // Change this to your desired width
      worksheet2.getColumn('C').width = 3.36; // Change this to your desired width
      worksheet2.getColumn('D').width = 37.55; // Change this to your desired width;
    
      // MergedCell for "Nomor Invoice" in column 2 with width 44,55
      worksheet2.getCell('B9').value = 'Nomor Invoice';
      worksheet2.getCell('B9').alignment = { horizontal: 'right' };
      worksheet2.mergeCells('B9:C9');
    
      // MergedCell for "Nomor Invoice" in column 3 with width 3,36
      worksheet2.getCell('D9').value = `INV/${moment().format('YYYY')}/${monthToRoman(moment().month() + 1)}/...`;
      worksheet2.getCell('D9').alignment = { horizontal: 'left' };

      // MergedCell for "Tanggal Invoice" in column 4
      worksheet2.getCell('B10').value = 'Tanggal Invoice';
      worksheet2.getCell('B10').alignment = { horizontal: 'right' };
      worksheet2.mergeCells('B10:C10');
    
      worksheet2.getCell('D10').value = moment().format('DD MMMM YYYY');
      worksheet2.getCell('D10').alignment = { horizontal: 'left' };
    
      // MergedCell for "Kepada Yth" in column 1
      worksheet2.getCell('A12').value = 'Kepada Yth';
      worksheet2.getCell('A12').alignment = { horizontal: 'left' };
      worksheet2.getCell('B13').value = ': PT UTC Aerospace Systems Bandung Operations';
      worksheet2.getCell('B14').value = 'Jl. Soekarno Hatta No.35, Cipadung Kidul';
      worksheet2.getCell('B15').value = 'Panyileukan, Kota Bandung, Jawa Barat 40614';

      // Border table in cells A17 to A26
      const tableStartRow = 17;

      // // Add table headers
      worksheet2.getCell(`A${tableStartRow}`).value = 'No';
      worksheet2.getCell(`A${tableStartRow}`).font = { bold: true };
      worksheet2.getCell(`A${tableStartRow}`).alignment = { horizontal: 'center' };
      worksheet2.getCell(`B${tableStartRow}`).value = 'Deskripsi';
      worksheet2.getCell(`B${tableStartRow}`).font = { bold: true };
      worksheet2.getCell(`B${tableStartRow}`).alignment = { horizontal: 'center' };
      worksheet2.mergeCells(`B${tableStartRow}:C${tableStartRow}`);
      worksheet2.getCell(`D${tableStartRow}`).value = 'Jumlah (IDR)';
      worksheet2.getCell(`D${tableStartRow}`).font = { bold: true };
      worksheet2.getCell(`D${tableStartRow}`).alignment = { horizontal: 'center' };

      worksheet2.getCell(`A18`).value = 1;
      worksheet2.getCell(`A18`).alignment = { horizontal: 'center' };
      worksheet2.getCell(`B18`).value = dataInvoice.sim_wajib.nama;
      worksheet2.mergeCells(`B18:C18`);
      worksheet2.getCell(`B18`).alignment = { horizontal: 'left' };
      worksheet2.getCell(`D18`).value = parseFloat(dataInvoice.sim_wajib.total).toLocaleString('id-ID');
      worksheet2.getCell(`D18`).alignment = { horizontal: 'right' };

      worksheet2.getCell(`A19`).value = 2;
      worksheet2.getCell(`A19`).alignment = { horizontal: 'center' };
      worksheet2.getCell(`B19`).value = dataInvoice.tabungan.nama;
      worksheet2.mergeCells(`B19:C19`);
      worksheet2.getCell(`B19`).alignment = { horizontal: 'left' };
      worksheet2.getCell(`D19`).value = parseFloat(dataInvoice.tabungan.total).toLocaleString('id-ID');
      worksheet2.getCell(`D19`).alignment = { horizontal: 'right' };
      
      worksheet2.getCell(`A20`).value = 3;
      worksheet2.getCell(`A20`).alignment = { horizontal: 'center' };
      worksheet2.getCell(`B20`).value = dataInvoice.sim_pokok.nama;
      worksheet2.mergeCells(`B20:C20`);
      worksheet2.getCell(`B20`).alignment = { horizontal: 'left' };
      worksheet2.getCell(`D20`).value = parseFloat(dataInvoice.sim_pokok.total).toLocaleString('id-ID');
      worksheet2.getCell(`D20`).alignment = { horizontal: 'right' };

      worksheet2.getCell(`A21`).value = 4;
      worksheet2.getCell(`A21`).alignment = { horizontal: 'center' };
      worksheet2.getCell(`B21`).value = dataInvoice.iuran_spn.nama;
      worksheet2.mergeCells(`B21:C21`);
      worksheet2.getCell(`B21`).alignment = { horizontal: 'left' };
      worksheet2.getCell(`D21`).value = parseFloat(dataInvoice.iuran_spn.total).toLocaleString('id-ID');
      worksheet2.getCell(`D21`).alignment = { horizontal: 'right' };

      worksheet2.getCell(`A22`).value = 5;
      worksheet2.getCell(`A22`).alignment = { horizontal: 'center' };
      worksheet2.getCell(`B22`).value = dataInvoice.tag_tunai.nama;
      worksheet2.mergeCells(`B22:C22`);
      worksheet2.getCell(`B22`).alignment = { horizontal: 'left' };
      worksheet2.getCell(`D22`).value = parseFloat(dataInvoice.tag_tunai.total).toLocaleString('id-ID');
      worksheet2.getCell(`D22`).alignment = { horizontal: 'right' };

      worksheet2.getCell(`A23`).value = 6;
      worksheet2.getCell(`A23`).alignment = { horizontal: 'center' };
      worksheet2.getCell(`B23`).value = dataInvoice.tag_brg.nama;
      worksheet2.mergeCells(`B23:C23`);
      worksheet2.getCell(`B23`).alignment = { horizontal: 'left' };
      worksheet2.getCell(`D23`).value = parseFloat(dataInvoice.tag_brg.total).toLocaleString('id-ID');
      worksheet2.getCell(`D23`).alignment = { horizontal: 'right' };

      worksheet2.getCell(`A24`).value = "";
      worksheet2.getCell(`B24`).value = dataInvoice.total.nama;
      worksheet2.getCell(`B24`).font = { bold: true };
      worksheet2.mergeCells(`B24:C24`);
      worksheet2.getCell(`B24`).alignment = { horizontal: 'right' };
      worksheet2.getCell(`D24`).value = parseFloat(dataInvoice.total.total).toLocaleString('id-ID');
      worksheet2.getCell(`D24`).font = { bold: true };
      worksheet2.getCell(`D24`).alignment = { horizontal: 'right' };
      
      worksheet2.getCell(`A25`).value = "";
      worksheet2.getCell(`B25`).value = "PPN";
      worksheet2.getCell(`B25`).font = { bold: true };
      worksheet2.mergeCells(`B25:C25`);
      worksheet2.getCell(`B25`).alignment = { horizontal: 'right' };
      worksheet2.getCell(`D25`).value = 0;
      worksheet2.getCell(`D25`).font = { bold: true };
      worksheet2.getCell(`D25`).alignment = { horizontal: 'right' };

      worksheet2.getCell(`A26`).value = "";
      worksheet2.getCell(`B26`).value = "Total Tagihan";
      worksheet2.getCell(`B26`).font = { bold: true };
      worksheet2.mergeCells(`B26:C26`);
      worksheet2.getCell(`B26`).alignment = { horizontal: 'right' };
      worksheet2.getCell(`D26`).value = parseFloat(dataInvoice.total.total).toLocaleString('id-ID');
      worksheet2.getCell(`D26`).font = { bold: true };
      worksheet2.getCell(`D26`).alignment = { horizontal: 'right' };

      worksheet2.getCell(`A28`).value = "Terbilang:";
      worksheet2.mergeCells(`A28:D28`);
      worksheet2.getCell(`A28`).alignment = { horizontal: 'left' };

      worksheet2.getCell(`D31`).value = "Koperasi Karyawan Aerospace Bandung";
      worksheet2.getCell(`D31`).font = { bold: true };
      worksheet2.getCell(`D31`).alignment = { horizontal: 'center' };

      worksheet2.getCell(`D37`).value = "ARI SAEPUDIN";
      worksheet2.getCell(`D37`).font = { bold: true, underline: true };
      worksheet2.getCell(`D37`).alignment = { horizontal: 'center' };

      worksheet2.getCell(`D38`).value = "Ketua Koperasi";
      worksheet2.getCell(`D38`).font = { bold: true };
      worksheet2.getCell(`D38`).alignment = { horizontal: 'center' };
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      // Create a download link and trigger the download
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `INVOICE ${moment(time).format("MMM YYYY")}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

    } catch (error) {
      console.error('Error exporting to Excel:', error);
      // Handle the error, show a message, or log it
    } finally {
      // Clear loading state, whether successful or with an error
      setIsLoading(false);
    }
  };
  
  // Helper function to convert image to base64
  const getBase64Image = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
  
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };


  const viewInvoice = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Rekap Invoice</b></p>
              </div>

              {/* Simpanan Wajib */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Total Simpanan Wajib
                </label>
                <input
                  value={"Rp." + parseFloat(dataInvoice.sim_wajib.total).toLocaleString('id-ID')}
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Simpanan Pokok */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Total Simpanan Pokok
                </label>
                <input
                  value={"Rp." + parseFloat(dataInvoice.sim_pokok.total).toLocaleString('id-ID')}
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Tabungan Berjangka */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Total Tabungan Berjangka
                </label>
                <input
                  value={"Rp." + parseFloat(dataInvoice.tabungan.total).toLocaleString('id-ID')}
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Iuran SPN */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Total Iuran SPN
                </label>
                <input
                  value={"Rp." + parseFloat(dataInvoice.iuran_spn.total).toLocaleString('id-ID')}
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Tagihan Pinjaman Tunai */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Total Tagihan Pinjaman Tunai
                </label>
                <input
                  value={"Rp." + parseFloat(dataInvoice.tag_tunai.total).toLocaleString('id-ID')}
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Tagihan Pinjaman Barang */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Total Tagihan Pinjaman Barang
                </label>
                <input
                  value={"Rp." + parseFloat(dataInvoice.tag_brg.total).toLocaleString('id-ID')}
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Total */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Total Tagihan
                </label>
                <input
                  value={"Rp." + parseFloat(dataInvoice.total.total).toLocaleString('id-ID')}
                  className="form-control"
                  readOnly
                />
              </div>

              <div className='col-md-3'>
                <label htmlFor='true' className='form-label text-success'>
                  Format dalam Excel (.xlsx)
                </label>
                <button
                  type="button"
                  className='btn btn-danger col-md-12'
                  style={{backgroundColor: '#CD5C08'}}
                  onClick={exportToExcel}
                >
                  Download Invoice
                </button>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading === false ? addView() : <LoadingView />}

      {showInv === true ? viewInvoice() : <></>}

    </div>
  );

}

export default Invoice;